import { AdminTableconstant } from "./AdminTableConstant";

const AdminTableAction = {};

AdminTableAction.getAdminTable = (payload) => {
    return {
        type: AdminTableconstant.ADMIN_TABLE_SAGA,
        payload:payload
    }
};

export { AdminTableAction };